import { Link, useLocation } from "react-router-dom";
import { Menu, Button, Drawer } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { useState } from "react";
import LogoImage from "../../assets/images/logo.png";
import "./NavigationBar.css";

const NavigationBar = () => {
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const currentKey = location.pathname.substring(1) || 'home';

    const [drawerVisible, setDrawerVisible] = useState(false);

    const menuOptions = [
        {
            label: <Link to="/" onClick={() => setDrawerVisible(false)}>Главная</Link>,
            key: 'home',
        },
        {
            label: <Link to="/aboutUs" onClick={() => setDrawerVisible(false)}>О нас</Link>,
            key: 'aboutUs',
        },
        {
            label: <Link to="/productions" onClick={() => setDrawerVisible(false)}>Продукция</Link>,
            key: 'productions',
        },
        {
            label: <Link to="/contacts" onClick={() => setDrawerVisible(false)}>Контакты</Link>,
            key: 'contacts',
        },
    ];

    const handleMenuClick = (key) => {
        setDrawerVisible(false);
        if (key === 'contacts') {
            scrollToFooter();
        }
    };

    const scrollToFooter = () => {
        const footer = document.getElementById('footer');
        if (footer) {
            footer.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <div className={`navbar-container ${isHomePage ? 'home-page' : 'other-page'}`}>
            <div className="navbar-desktop">
                {
                    !isHomePage && (
                        <div>
                            <Link to="/">
                                <img
                                    src={LogoImage}
                                    alt="Логотип"
                                    className="navbar-container-logo"
                                />
                            </Link>
                        </div>
                    )
                }
                <Menu
                    className="navbar-menu"
                    selectedKeys={[currentKey]}
                    mode="horizontal"
                    items={menuOptions}
                    onClick={({key}) => handleMenuClick(key)}
                />
            </div>

            {/* Мобильное меню */}
            <div className="navbar-mobile">
                <Button
                    type="text"
                    icon={<MenuOutlined/>}
                    onClick={() => setDrawerVisible(true)}
                    className="burger-button"
                />
            </div>

            {/* Drawer для мобильного меню */}
            <Drawer
                title={
                    <div className="drawer-header">
                        <span>Меню</span>
                    </div>
                }
                placement="right"
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
                className="mobile-menu-drawer"
                width="280px"
            >
                <Menu
                    mode="vertical"
                    selectedKeys={[currentKey]}
                    items={menuOptions}
                    className="mobile-menu"
                    onClick={({key}) => handleMenuClick(key)}
                />
            </Drawer>
        </div>
    );
};

export default NavigationBar;